module.exports = __webpack_public_path__ + "img/fb.db5cff25.svg";